import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { TANDC_kr, TANDC_ca, TANDC_cn } from "../../tandc";
import "./Footer.css";

const TandC = () => {
    const { t } = useTranslation();
    const lang = useSelector((state) => state.app.lang);
    const TANDC =
        lang === "kr" ? TANDC_kr : lang === "cn" ? TANDC_cn : TANDC_ca; // Default to TANDC_ca for other languages

    return (
        <>
            <div className="contentContainer">
                <div className="contentTitle">{t("TandC")}</div>
                <div
                    className="htmlDiv"
                    dangerouslySetInnerHTML={{
                        __html: TANDC,
                    }}
                />
            </div>
        </>
    );
};

export default TandC;
